module.exports = __webpack_public_path__ + "static/media/rules-r.40808da4.png";